// ENHANCEMENT - this can use a tighten-up. We should be able to set max-pages-displayed (name?)
const inner_window = 1;
const outer_window = 1;

// Constant used to identify when to render "..." in <Pagination />
export const ELLIPSIS_SPACER = -1;

/**
 * getWindowedPageData
 * Returns array that look like [1,2, "...", 5,6,7,8, "...", 19,20]
 *                                ^            ^             ^
 *                         outer_window  inner_window  outer_window
 * This is used to build the UI in the <Pagination /> component
 * By the way this code looks like shit because it was
 * compiled from some old CoffeeScript code from 2016 :P
 */
export function getWindowedPageData(props: {
    currentPage: number;
    totalPages: number;
}): number[] {
    const { currentPage, totalPages } = props;

    let window_from = currentPage - inner_window;
    let window_to = currentPage + inner_window;

    if (window_to > totalPages) {
        window_from -= window_to - totalPages;
        window_to = totalPages;
    }

    if (window_from < 1) {
        window_to += 1 - window_from;
        window_from = 1;

        if (window_to > totalPages) {
            window_to = totalPages;
        }
    }

    // console.log("window_from: ", window_from);
    // console.log("window_to: ", window_to);

    let _results: number[] = [];
    const middle = (function () {
        _results = [];
        for (
            var _i = window_from;
            window_from <= window_to ? _i <= window_to : _i >= window_to;
            window_from <= window_to ? _i++ : _i--
        ) {
            _results.push(_i);
        }
        return _results;
    })();

    // // // //
    // Calculate Left
    let left: any[] = [];
    let _results1: any[] = [];
    let _results2: any[] = [];
    if (outer_window + 3 < middle[0]) {
        left = (function () {
            _results1 = [];
            for (
                var _j = 1, _ref = outer_window + 1;
                1 <= _ref ? _j <= _ref : _j >= _ref;
                1 <= _ref ? _j++ : _j--
            ) {
                _results1.push(_j);
            }
            return _results1;
        })();
        left.push(ELLIPSIS_SPACER);
    } else {
        left = (function () {
            _results2 = [];
            for (
                var _k = 1, _ref1 = middle[0];
                1 <= _ref1 ? _k < _ref1 : _k > _ref1;
                1 <= _ref1 ? _k++ : _k--
            ) {
                _results2.push(_k);
            }
            return _results2;
        })();
    }

    // Calculate Right
    let right: any[] = [];
    let _results3: any[] = [];
    let _results4: any[] = [];
    let _ref2: any = null;
    if (totalPages - outer_window - 2 > middle[middle.length - 1]) {
        right = (function () {
            _results3 = [];
            for (
                var _l = (_ref2 = totalPages - outer_window);
                _ref2 <= totalPages ? _l <= totalPages : _l >= totalPages;
                _ref2 <= totalPages ? _l++ : _l--
            ) {
                _results3.push(_l);
            }
            return _results3;
        })();
        right.unshift(ELLIPSIS_SPACER);
    } else {
        let right_start = Math.min(middle[middle.length - 1] + 1, totalPages);
        // console.log("right_start ", right_start);
        right = (function () {
            _results4 = [];
            for (
                var _m = right_start;
                right_start <= totalPages ? _m <= totalPages : _m >= totalPages;
                right_start <= totalPages ? _m++ : _m--
            ) {
                _results4.push(_m);
            }
            return _results4;
        })();
        // console.log("right before clear");
        // console.log(right);

        if (right_start === middle[middle.length - 1]) {
            // console.log("CLEAR RIGHT");
            right = [];
        }
    }

    // // // //

    // Shown pages
    // console.log(left);
    // console.log(middle);
    // console.log(right);
    return left.concat(middle.concat(right));
}
